<app-contract-details> </app-contract-details>
